import gql from 'graphql-tag';
import {apolloClient} from '@/apollo';
import useMyOrder from 'hooks/useMyOrder';
import useMyOrders from 'hooks/useMyOrders';

export const loginVars = (email, password) => ({
  draft: {
    email,
    password,
  },
});
const createResetToken = (email) =>
  apolloClient.mutate({
    mutation: gql`
      mutation createResetToken($email: String!) {
        customerCreatePasswordResetToken(email: $email) {
          value
        }
      }
    `,
    variables: {
      email,
    },
  });
const returnItems = (id, version, items) => {
  return apolloClient.mutate({
    mutation: gql`
      mutation returnItems(
        $id: String
        $version: Long!
        $items: [ReturnItemDraftType!]!
      ) {
        updateOrder(
          version: $version
          id: $id
          actions: { addReturnInfo: { items: $items } }
        ) {
          orderNumber
        }
      }
    `,
    variables: {
      id,
      version,
      items: items.map((item) => ({
        ...item,
        shipmentState: 'Advised',
      })),
    },
  });
};
const resetPassword = ({token, newPassword}) =>
  apolloClient.mutate({
    mutation: gql`
      mutation resetPassword(
        $tokenValue: String!
        $newPassword: String!
      ) {
        customerResetPassword(
          tokenValue: $tokenValue
          newPassword: $newPassword
        ) {
          firstName
        }
      }
    `,
    variables: {
      tokenValue: token,
      newPassword,
    },
  });
const signup = (form) => {
  return apolloClient.mutate({
    mutation: gql`
      mutation customerSignMeUp(
        $draft: CustomerSignMeUpDraft!
      ) {
        customerSignMeUp(draft: $draft) {
          customer {
            customerId: id
            firstName
            lastName
            email
            version
            customerNumber
            customerGroupRef {
              customerGroupId: id
            }
          }
        }
      }
    `,
    variables: {
      draft: {
        email: form.email,
        password: form.password,
        firstName: form.firstName,
        lastName: form.lastName,
      },
    },
  });
};
const updateUser = ({
                      version,
                      firstName,
                      lastName,
                      email,
                    }) =>
  apolloClient.mutate({
    mutation: gql`
      mutation updateMyCustomer(
        $actions: [MyCustomerUpdateAction!]!
        $version: Long!
      ) {
        updateMyCustomer(
          version: $version
          actions: $actions
        ) {
          customerId: id
          version
          email
          firstName
          lastName
          version
          customerGroupRef {
            customerGroupId: id
          }
        }
      }
    `,
    variables: {
      version,
      actions: [
        {changeEmail: {email}},
        {setFirstName: {firstName}},
        {setLastName: {lastName}},
      ],
    },
  });
const login = (email, password) =>
  apolloClient.mutate({
    mutation: gql`
      mutation customerSignMeIn(
        $draft: CustomerSignMeInDraft!
      ) {
        customerSignMeIn(draft: $draft) {
          customer {
            customerId: id
            firstName
            lastName
            email
            customerNumber
            version
            customerGroupRef {
              customerGroupId: id
            }
          }
        }
      }
    `,
    variables: loginVars(email, password),
  });

function stringGen() {
  var result = '';
  var input_length = 12;
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < input_length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

const createPetForUser = (form) => {
  console.log(form);
  const charSlug = stringGen();
  const slugKey = charSlug + "_" + form.Pet_name.replace(" ", "_");
  const responseProductCreation = apolloClient.mutate({
    mutation: gql`
      mutation createProduct($draft: ProductDraft!) {
        createProduct(draft: $draft) {
          id
          skus
          key
          version
        }
      }
    `,
    variables: {
      draft: {
        name: [
          {value: form.Pet_name, locale: "en"},
          {value: form.Pet_name, locale: "de"},
          {value: form.Pet_name, locale: "de-DE"},
          {value: form.Pet_name, locale: "en-GB"},
        ],
        // image: form.image,
        productType: {key: "pet"},
        slug: [
          {value: slugKey, locale: "en"},
          {value: slugKey, locale: "de"},
          {value: slugKey, locale: "de-DE"},
          {value: slugKey, locale: "en-GB"}
        ],
        publish: true,
        categories: [{key: "pets"}],
        masterVariant: {
          sku: slugKey,
          images: [
            {
              url: "https://res.cloudinary.com/testo-esolution-machaton-2022/image/upload/v1653311986/Website%20Petsy/website/andrew-s-ouo1hbizWwo-unsplash_ua3sr8.jpg",
              dimensions: {width: 4160, height: 4160}
            }
          ],
          attributes: [
            {name: "Pet_Size", value: "\"" + form.Pet_Size + "\""},
            {name: "Pet_age", value: form.Pet_age},
            {name: "Pet_breed", value: "\"" + form.Pet_breed + "\""},
            {name: "Pet_name", value: "\"" + form.Pet_name + "\""},
            {name: "Allergies___diseases", value: "\"" + form.Allergies__diseases + "\""},
            {name: "Vaccinations", value: "\"" + form.Vaccinations + "\""},
            {name: "smoobu-booking", value: "\"{'provider':'4','category':'1'}\""},
            // { // not supported atm (beta)\
            //   name: "customer-relation", value: {
            //     typeId: "customer", id: "5d721e94-6643-4cce-af4d-a7e3a5c6823f"
            //   }
            // },
            // { // not supported atm (beta): https://docs.commercetools.com/api/projects/productTypes#nestedtype
            //   name: "general-information", value: [
            //     {name: "short_description", value: "\"" + form.short_description + "\"", locale: "de"},
            //     {name: "Extra_information", value: "\"" + form.Extra_information + "\""}
            //   ]
            // },
          ],
          prices: [{
            value: {centPrecision: {currencyCode: "GBP", centAmount: 12000}}, country: "GB"
          }, {
            value: {centPrecision: {currencyCode: "EUR", centAmount: 10000}}, country: "DE"
          }]
        }
      },
    }
  });
  apolloClient.mutate({
    mutation: gql`
      mutation createInventoryEntry($draft: InventoryEntryDraft!) {
        createInventoryEntry(draft: $draft) {
          id
        }
      }
    `,
    variables: {
      draft: {
        sku: slugKey,
        quantityOnStock: 25
      },
    }
  });

  return responseProductCreation;
}

const updateMyCustomerPassword = ({
                                    currentPassword,
                                    newPassword,
                                    version,
                                  }) => {
  return apolloClient.mutate({
    mutation: gql`
      mutation changePassword(
        $version: Long!
        $currentPassword: String!
        $newPassword: String!
      ) {
        customerChangeMyPassword(
          version: $version
          currentPassword: $currentPassword
          newPassword: $newPassword
        ) {
          customerId: id
          firstName
          lastName
          email
          customerNumber
          version
          customerGroupRef {
            customerGroupId: id
          }
        }
      }
    `,
    variables: {
      version,
      currentPassword,
      newPassword,
    },
  });
};

export default {
  signup,
  updateUser,
  createResetToken,
  resetPassword,
  useMyOrders,
  useMyOrder,
  returnItems,
  updateMyCustomerPassword,
  login,
  createPetForUser,
};
